/**
 * Do not edit directly, this file was auto-generated.
 */

export const GL_BORDER_COLOR_TRANSPARENT = 'transparent';
export const GL_BORDER_COLOR_DEFAULT = '#dcdcde';
export const GL_BORDER_COLOR_SUBTLE = '#ececef';
export const GL_BORDER_COLOR_STRONG = '#bfbfc3';
export const GL_BORDER_COLOR_SECTION = '#dcdcde';
export const GL_BORDER_RADIUS_NONE = '0';
export const GL_BORDER_RADIUS_XS = '1px';
export const GL_BORDER_RADIUS_SM = '0.125rem';
export const GL_BORDER_RADIUS_MD = '0.25rem';
export const GL_BORDER_RADIUS_LG = '0.5rem';
export const GL_BORDER_RADIUS_XL = '0.75rem';
export const GL_BORDER_RADIUS_2XL = '1rem';
export const GL_BORDER_RADIUS_3XL = '1.5rem';
export const GL_BORDER_RADIUS_FULL = '9999px';
export const GL_BORDER_RADIUS_DEFAULT = '0.25rem';
export const GL_COLOR_ALPHA_0 = 'transparent';
export const GL_COLOR_ALPHA_DARK_2 = 'rgba(05, 05, 06, 0.02)';
export const GL_COLOR_ALPHA_DARK_4 = 'rgba(05, 05, 06, 0.04)';
export const GL_COLOR_ALPHA_DARK_6 = 'rgba(05, 05, 06, 0.06)';
export const GL_COLOR_ALPHA_DARK_8 = 'rgba(05, 05, 06, 0.08)';
export const GL_COLOR_ALPHA_DARK_16 = 'rgba(05, 05, 06, 0.16)';
export const GL_COLOR_ALPHA_DARK_24 = 'rgba(05, 05, 06, 0.24)';
export const GL_COLOR_ALPHA_DARK_40 = 'rgba(05, 05, 06, 0.4)';
export const GL_COLOR_ALPHA_LIGHT_2 = 'rgba(255, 255, 255, 0.02)';
export const GL_COLOR_ALPHA_LIGHT_4 = 'rgba(255, 255, 255, 0.04)';
export const GL_COLOR_ALPHA_LIGHT_6 = 'rgba(255, 255, 255, 0.06)';
export const GL_COLOR_ALPHA_LIGHT_8 = 'rgba(255, 255, 255, 0.08)';
export const GL_COLOR_ALPHA_LIGHT_16 = 'rgba(255, 255, 255, 0.16)';
export const GL_COLOR_ALPHA_LIGHT_24 = 'rgba(255, 255, 255, 0.24)';
export const GL_COLOR_ALPHA_LIGHT_36 = 'rgba(255, 255, 255, 0.36)';
export const GL_COLOR_BLUE_50 = '#e9f3fc';
export const GL_COLOR_BLUE_100 = '#cbe2f9';
export const GL_COLOR_BLUE_200 = '#9dc7f1';
export const GL_COLOR_BLUE_300 = '#63a6e9';
export const GL_COLOR_BLUE_400 = '#428fdc';
export const GL_COLOR_BLUE_500 = '#1f75cb';
export const GL_COLOR_BLUE_600 = '#2f68b4';
export const GL_COLOR_BLUE_700 = '#2f5ca0';
export const GL_COLOR_BLUE_800 = '#284779';
export const GL_COLOR_BLUE_900 = '#213454';
export const GL_COLOR_BLUE_950 = '#1d283e';
export const GL_COLOR_NEUTRAL_0 = '#fff';
export const GL_COLOR_NEUTRAL_10 = '#fbfafd';
export const GL_COLOR_NEUTRAL_50 = '#ececef';
export const GL_COLOR_NEUTRAL_100 = '#dcdcde';
export const GL_COLOR_NEUTRAL_200 = '#bfbfc3';
export const GL_COLOR_NEUTRAL_300 = '#a4a3a8';
export const GL_COLOR_NEUTRAL_400 = '#89888d';
export const GL_COLOR_NEUTRAL_500 = '#737278';
export const GL_COLOR_NEUTRAL_600 = '#626168';
export const GL_COLOR_NEUTRAL_700 = '#4c4b51';
export const GL_COLOR_NEUTRAL_800 = '#3a383f';
export const GL_COLOR_NEUTRAL_900 = '#28272d';
export const GL_COLOR_NEUTRAL_950 = '#18171d';
export const GL_COLOR_NEUTRAL_1000 = '#050506';
export const GL_COLOR_GREEN_50 = '#ecf4ee';
export const GL_COLOR_GREEN_100 = '#c3e6cd';
export const GL_COLOR_GREEN_200 = '#91d4a8';
export const GL_COLOR_GREEN_300 = '#52b87a';
export const GL_COLOR_GREEN_400 = '#2da160';
export const GL_COLOR_GREEN_500 = '#108548';
export const GL_COLOR_GREEN_600 = '#2f7549';
export const GL_COLOR_GREEN_700 = '#306440';
export const GL_COLOR_GREEN_800 = '#225131';
export const GL_COLOR_GREEN_900 = '#1e3e28';
export const GL_COLOR_GREEN_950 = '#17291c';
export const GL_COLOR_ORANGE_50 = '#fdf1dd';
export const GL_COLOR_ORANGE_100 = '#f5d9a8';
export const GL_COLOR_ORANGE_200 = '#e9be74';
export const GL_COLOR_ORANGE_300 = '#d99530';
export const GL_COLOR_ORANGE_400 = '#c17d10';
export const GL_COLOR_ORANGE_500 = '#ab6100';
export const GL_COLOR_ORANGE_600 = '#995715';
export const GL_COLOR_ORANGE_700 = '#894b16';
export const GL_COLOR_ORANGE_800 = '#693c14';
export const GL_COLOR_ORANGE_900 = '#532e16';
export const GL_COLOR_ORANGE_950 = '#382315';
export const GL_COLOR_PURPLE_50 = '#f4f0ff';
export const GL_COLOR_PURPLE_100 = '#e1d8f9';
export const GL_COLOR_PURPLE_200 = '#cbbbf2';
export const GL_COLOR_PURPLE_300 = '#ac93e6';
export const GL_COLOR_PURPLE_400 = '#9475db';
export const GL_COLOR_PURPLE_500 = '#7b58cf';
export const GL_COLOR_PURPLE_600 = '#6a4fb4';
export const GL_COLOR_PURPLE_700 = '#5c47a6';
export const GL_COLOR_PURPLE_800 = '#493c83';
export const GL_COLOR_PURPLE_900 = '#342d59';
export const GL_COLOR_PURPLE_950 = '#27243e';
export const GL_COLOR_RED_50 = '#fcf1ef';
export const GL_COLOR_RED_100 = '#fdd4cd';
export const GL_COLOR_RED_200 = '#fcb5aa';
export const GL_COLOR_RED_300 = '#f6806d';
export const GL_COLOR_RED_400 = '#ec5941';
export const GL_COLOR_RED_500 = '#dd2b0e';
export const GL_COLOR_RED_600 = '#c02f12';
export const GL_COLOR_RED_700 = '#a32c12';
export const GL_COLOR_RED_800 = '#812713';
export const GL_COLOR_RED_900 = '#582014';
export const GL_COLOR_RED_950 = '#3e1a14';
export const GL_COLOR_DATA_GREEN_50 = '#ddfab7';
export const GL_COLOR_DATA_GREEN_100 = '#c6ed94';
export const GL_COLOR_DATA_GREEN_200 = '#b0d97b';
export const GL_COLOR_DATA_GREEN_300 = '#94c25e';
export const GL_COLOR_DATA_GREEN_400 = '#81ac41';
export const GL_COLOR_DATA_GREEN_500 = '#619025';
export const GL_COLOR_DATA_GREEN_600 = '#4e7f0e';
export const GL_COLOR_DATA_GREEN_700 = '#366800';
export const GL_COLOR_DATA_GREEN_800 = '#275600';
export const GL_COLOR_DATA_GREEN_900 = '#1a4500';
export const GL_COLOR_DATA_GREEN_950 = '#133a03';
export const GL_COLOR_DATA_AQUA_50 = '#b5fefd';
export const GL_COLOR_DATA_AQUA_100 = '#93f2ef';
export const GL_COLOR_DATA_AQUA_200 = '#5edee3';
export const GL_COLOR_DATA_AQUA_300 = '#32c5d2';
export const GL_COLOR_DATA_AQUA_400 = '#00acc4';
export const GL_COLOR_DATA_AQUA_500 = '#0090b1';
export const GL_COLOR_DATA_AQUA_600 = '#007b9b';
export const GL_COLOR_DATA_AQUA_700 = '#006381';
export const GL_COLOR_DATA_AQUA_800 = '#00516c';
export const GL_COLOR_DATA_AQUA_900 = '#004059';
export const GL_COLOR_DATA_AQUA_950 = '#00344b';
export const GL_COLOR_DATA_BLUE_50 = '#e9ebff';
export const GL_COLOR_DATA_BLUE_100 = '#d2dcff';
export const GL_COLOR_DATA_BLUE_200 = '#b7c6ff';
export const GL_COLOR_DATA_BLUE_300 = '#97acff';
export const GL_COLOR_DATA_BLUE_400 = '#7992f5';
export const GL_COLOR_DATA_BLUE_500 = '#617ae2';
export const GL_COLOR_DATA_BLUE_600 = '#4e65cd';
export const GL_COLOR_DATA_BLUE_700 = '#3f51ae';
export const GL_COLOR_DATA_BLUE_800 = '#374291';
export const GL_COLOR_DATA_BLUE_900 = '#303470';
export const GL_COLOR_DATA_BLUE_950 = '#2a2b59';
export const GL_COLOR_DATA_MAGENTA_50 = '#ffe3eb';
export const GL_COLOR_DATA_MAGENTA_100 = '#ffccdb';
export const GL_COLOR_DATA_MAGENTA_200 = '#fcacc5';
export const GL_COLOR_DATA_MAGENTA_300 = '#f88aaf';
export const GL_COLOR_DATA_MAGENTA_400 = '#e86e9a';
export const GL_COLOR_DATA_MAGENTA_500 = '#cf4d81';
export const GL_COLOR_DATA_MAGENTA_600 = '#b93d71';
export const GL_COLOR_DATA_MAGENTA_700 = '#9a2e5d';
export const GL_COLOR_DATA_MAGENTA_800 = '#7c214f';
export const GL_COLOR_DATA_MAGENTA_900 = '#661e3a';
export const GL_COLOR_DATA_MAGENTA_950 = '#541d31';
export const GL_COLOR_DATA_ORANGE_50 = '#fae8d1';
export const GL_COLOR_DATA_ORANGE_100 = '#f5d6b3';
export const GL_COLOR_DATA_ORANGE_200 = '#eebd8c';
export const GL_COLOR_DATA_ORANGE_300 = '#e99b60';
export const GL_COLOR_DATA_ORANGE_400 = '#e07e41';
export const GL_COLOR_DATA_ORANGE_500 = '#c95d2e';
export const GL_COLOR_DATA_ORANGE_600 = '#b14f18';
export const GL_COLOR_DATA_ORANGE_700 = '#92430a';
export const GL_COLOR_DATA_ORANGE_800 = '#6f3500';
export const GL_COLOR_DATA_ORANGE_900 = '#5e2f05';
export const GL_COLOR_DATA_ORANGE_950 = '#4b2707';
export const GL_COLOR_THEME_INDIGO_10 = '#f8f8ff';
export const GL_COLOR_THEME_INDIGO_50 = '#f1f1ff';
export const GL_COLOR_THEME_INDIGO_100 = '#dbdbf8';
export const GL_COLOR_THEME_INDIGO_200 = '#c7c7f2';
export const GL_COLOR_THEME_INDIGO_300 = '#a2a2e6';
export const GL_COLOR_THEME_INDIGO_400 = '#8181d7';
export const GL_COLOR_THEME_INDIGO_500 = '#6666c4';
export const GL_COLOR_THEME_INDIGO_600 = '#5252b5';
export const GL_COLOR_THEME_INDIGO_700 = '#41419f';
export const GL_COLOR_THEME_INDIGO_800 = '#303083';
export const GL_COLOR_THEME_INDIGO_900 = '#222261';
export const GL_COLOR_THEME_INDIGO_950 = '#14143d';
export const GL_COLOR_THEME_BLUE_10 = '#e6ecf0';
export const GL_COLOR_THEME_BLUE_50 = '#cdd8e3';
export const GL_COLOR_THEME_BLUE_100 = '#b9cadc';
export const GL_COLOR_THEME_BLUE_200 = '#a6bdd5';
export const GL_COLOR_THEME_BLUE_300 = '#81a5c9';
export const GL_COLOR_THEME_BLUE_400 = '#628eb9';
export const GL_COLOR_THEME_BLUE_500 = '#4977a5';
export const GL_COLOR_THEME_BLUE_600 = '#346596';
export const GL_COLOR_THEME_BLUE_700 = '#235180';
export const GL_COLOR_THEME_BLUE_800 = '#153c63';
export const GL_COLOR_THEME_BLUE_900 = '#0b2640';
export const GL_COLOR_THEME_BLUE_950 = '#04101c';
export const GL_COLOR_THEME_LIGHT_BLUE_10 = '#eef3f7';
export const GL_COLOR_THEME_LIGHT_BLUE_50 = '#dde6ee';
export const GL_COLOR_THEME_LIGHT_BLUE_100 = '#c1d4e6';
export const GL_COLOR_THEME_LIGHT_BLUE_200 = '#a0bedc';
export const GL_COLOR_THEME_LIGHT_BLUE_300 = '#74a3d3';
export const GL_COLOR_THEME_LIGHT_BLUE_400 = '#4f8bc7';
export const GL_COLOR_THEME_LIGHT_BLUE_500 = '#3476b9';
export const GL_COLOR_THEME_LIGHT_BLUE_600 = '#2268ae';
export const GL_COLOR_THEME_LIGHT_BLUE_700 = '#145aa1';
export const GL_COLOR_THEME_LIGHT_BLUE_800 = '#0e4d8d';
export const GL_COLOR_THEME_LIGHT_BLUE_900 = '#0c4277';
export const GL_COLOR_THEME_LIGHT_BLUE_950 = '#0a3764';
export const GL_COLOR_THEME_GREEN_10 = '#eef4ef';
export const GL_COLOR_THEME_GREEN_50 = '#dde9de';
export const GL_COLOR_THEME_GREEN_100 = '#b1d6b5';
export const GL_COLOR_THEME_GREEN_200 = '#8cc497';
export const GL_COLOR_THEME_GREEN_300 = '#69af7d';
export const GL_COLOR_THEME_GREEN_400 = '#499767';
export const GL_COLOR_THEME_GREEN_500 = '#308258';
export const GL_COLOR_THEME_GREEN_600 = '#25744c';
export const GL_COLOR_THEME_GREEN_700 = '#1b653f';
export const GL_COLOR_THEME_GREEN_800 = '#155635';
export const GL_COLOR_THEME_GREEN_900 = '#0e4328';
export const GL_COLOR_THEME_GREEN_950 = '#052e19';
export const GL_COLOR_THEME_RED_10 = '#faf4f3';
export const GL_COLOR_THEME_RED_50 = '#f4e9e7';
export const GL_COLOR_THEME_RED_100 = '#ecd3d0';
export const GL_COLOR_THEME_RED_200 = '#e3bab5';
export const GL_COLOR_THEME_RED_300 = '#d59086';
export const GL_COLOR_THEME_RED_400 = '#c66e60';
export const GL_COLOR_THEME_RED_500 = '#ad4a3b';
export const GL_COLOR_THEME_RED_600 = '#a13322';
export const GL_COLOR_THEME_RED_700 = '#8f2110';
export const GL_COLOR_THEME_RED_800 = '#761405';
export const GL_COLOR_THEME_RED_900 = '#580d02';
export const GL_COLOR_THEME_RED_950 = '#380700';
export const GL_COLOR_THEME_LIGHT_RED_10 = '#fdf9f8';
export const GL_COLOR_THEME_LIGHT_RED_50 = '#faf2f1';
export const GL_COLOR_THEME_LIGHT_RED_100 = '#f6d9d5';
export const GL_COLOR_THEME_LIGHT_RED_200 = '#ebada2';
export const GL_COLOR_THEME_LIGHT_RED_300 = '#e07f6f';
export const GL_COLOR_THEME_LIGHT_RED_400 = '#d36250';
export const GL_COLOR_THEME_LIGHT_RED_500 = '#c24b38';
export const GL_COLOR_THEME_LIGHT_RED_600 = '#b53a26';
export const GL_COLOR_THEME_LIGHT_RED_700 = '#a02e1c';
export const GL_COLOR_THEME_LIGHT_RED_800 = '#8b2212';
export const GL_COLOR_THEME_LIGHT_RED_900 = '#751709';
export const GL_COLOR_THEME_LIGHT_RED_950 = '#5c1105';
export const GL_COLOR_BRAND_WHITE = '#fff';
export const GL_COLOR_BRAND_CHARCOAL = '#171321';
export const GL_COLOR_BRAND_ORANGE_01G = '#ffd1bf';
export const GL_COLOR_BRAND_ORANGE_01P = '#fca326';
export const GL_COLOR_BRAND_ORANGE_02P = '#fc6d26';
export const GL_COLOR_BRAND_ORANGE_03P = '#e24329';
export const GL_COLOR_BRAND_PURPLE_01G = '#ceb3ef';
export const GL_COLOR_BRAND_PURPLE_01P = '#a989f5';
export const GL_COLOR_BRAND_PURPLE_02P = '#7759c2';
export const GL_COLOR_BRAND_GRAY_01 = '#d1d0d3';
export const GL_COLOR_BRAND_GRAY_02 = '#a2a1a6';
export const GL_COLOR_BRAND_GRAY_03 = '#74717a';
export const GL_COLOR_BRAND_GRAY_04 = '#45424d';
export const GL_COLOR_BRAND_GRAY_05 = '#2b2838';
export const GL_COLOR_BRAND_PINK_01G = '#ffb9c9';
export const GL_FONT_FAMILY_REGULAR = [
  "var(--default-regular-font, 'GitLab Sans')",
  '-apple-system',
  'BlinkMacSystemFont',
  "'Segoe UI'",
  'Roboto',
  "'Noto Sans'",
  'Ubuntu',
  'Cantarell',
  "'Helvetica Neue'",
  'sans-serif',
  "'Apple Color Emoji'",
  "'Segoe UI Emoji'",
  "'Segoe UI Symbol'",
  "'Noto Color Emoji'",
];
export const GL_FONT_FAMILY_MONOSPACE = [
  "var(--default-mono-font, 'GitLab Mono')",
  "'JetBrains Mono'",
  'Menlo',
  "'DejaVu Sans Mono'",
  "'Liberation Mono'",
  'Consolas',
  "'Ubuntu Mono'",
  "'Courier New'",
  "'andale mono'",
  "'lucida console'",
  'monospace',
];
export const GL_FONT_SIZE_100 = '0.75rem';
export const GL_FONT_SIZE_200 = '0.8125rem';
export const GL_FONT_SIZE_300 = '0.875rem';
export const GL_FONT_SIZE_400 = '1rem';
export const GL_FONT_SIZE_500 = 'clamp(1.125rem, 0.9027777778rem + 0.462962963vw, 1.25rem)';
export const GL_FONT_SIZE_600 = 'clamp(1.3125rem, 0.8680555556rem + 0.9259259259vw, 1.5625rem)';
export const GL_FONT_SIZE_700 = 'clamp(1.5rem, 0.8333333333rem + 1.3888888889vw, 1.875rem)';
export const GL_FONT_SIZE_800 = 'clamp(1.75rem, 0.8611111111rem + 1.8518518519vw, 2.25rem)';
export const GL_FONT_SIZE_XS = '0.625rem';
export const GL_FONT_SIZE_SM = '0.75rem';
export const GL_FONT_SIZE_MD = '0.875rem';
export const GL_FONT_SIZE_LG = '1rem';
export const GL_FONT_SIZE_100_FIXED = '0.75rem';
export const GL_FONT_SIZE_200_FIXED = '0.8125rem';
export const GL_FONT_SIZE_300_FIXED = '0.875rem';
export const GL_FONT_SIZE_400_FIXED = '1rem';
export const GL_FONT_SIZE_500_FIXED = '1.125rem';
export const GL_FONT_SIZE_600_FIXED = '1.3125rem';
export const GL_FONT_SIZE_700_FIXED = '1.5rem';
export const GL_FONT_SIZE_800_FIXED = '1.75rem';
export const GL_FONT_SIZE_BASE = '0.875rem';
export const GL_FONT_WEIGHT_100 = '100';
export const GL_FONT_WEIGHT_300 = '300';
export const GL_FONT_WEIGHT_NORMAL = '400';
export const GL_FONT_WEIGHT_SEMIBOLD = '500';
export const GL_FONT_WEIGHT_BOLD = '600';
export const GL_LINE_HEIGHT_12 = '0.75rem';
export const GL_LINE_HEIGHT_16 = '1rem';
export const GL_LINE_HEIGHT_20 = '1.25rem';
export const GL_LINE_HEIGHT_24 = '1.5rem';
export const GL_LINE_HEIGHT_28 = '1.75rem';
export const GL_LINE_HEIGHT_32 = '2rem';
export const GL_LINE_HEIGHT_36 = '2.25rem';
export const GL_LINE_HEIGHT_42 = '2.625rem';
export const GL_LINE_HEIGHT_44 = '2.75rem';
export const GL_LINE_HEIGHT_52 = '3.25rem';
export const GL_OPACITY_0 = '0';
export const GL_OPACITY_1 = '.1';
export const GL_OPACITY_2 = '.2';
export const GL_OPACITY_3 = '.3';
export const GL_OPACITY_4 = '.4';
export const GL_OPACITY_5 = '.5';
export const GL_OPACITY_6 = '.6';
export const GL_OPACITY_7 = '.7';
export const GL_OPACITY_8 = '.8';
export const GL_OPACITY_9 = '.9';
export const GL_OPACITY_10 = '1';
export const GL_SHADOW_SM = [
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: 0,
    blur: '2px',
    spread: 0,
  },
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: '1px',
    blur: '4px',
    spread: 0,
  },
];
export const GL_SHADOW_MD = [
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: 0,
    blur: '1px',
    spread: 0,
  },
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: 0,
    blur: '2px',
    spread: 0,
  },
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: '2px',
    blur: '8px',
    spread: 0,
  },
];
export const GL_SHADOW_LG = [
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: 0,
    blur: '2px',
    spread: 0,
  },
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: 0,
    blur: '2px',
    spread: 0,
  },
  {
    color: 'rgba(05, 05, 06, 0.16)',
    offsetX: 0,
    offsetY: '4px',
    blur: '12px',
    spread: 0,
  },
];
export const GL_SHADOW_COLOR_DEFAULT = 'rgba(05, 05, 06, 0.16)';
export const GL_SPACING_SCALE_0 = '0';
export const GL_SPACING_SCALE_1 = '0.125rem';
export const GL_SPACING_SCALE_2 = '0.25rem';
export const GL_SPACING_SCALE_3 = '0.5rem';
export const GL_SPACING_SCALE_4 = '0.75rem';
export const GL_SPACING_SCALE_5 = '1rem';
export const GL_SPACING_SCALE_6 = '1.5rem';
export const GL_SPACING_SCALE_7 = '2rem';
export const GL_SPACING_SCALE_8 = '2.5rem';
export const GL_SPACING_SCALE_9 = '3rem';
export const GL_SPACING_SCALE_10 = '3.5rem';
export const GL_SPACING_SCALE_11 = '4rem';
export const GL_SPACING_SCALE_12 = '5rem';
export const GL_SPACING_SCALE_13 = '6rem';
export const GL_SPACING_SCALE_15 = '7.5rem';
export const GL_SPACING_SCALE_18 = '9rem';
export const GL_SPACING_SCALE_20 = '10rem';
export const GL_SPACING_SCALE_26 = '13rem';
export const GL_SPACING_SCALE_28 = '14rem';
export const GL_SPACING_SCALE_30 = '15rem';
export const GL_SPACING_SCALE_31 = '15.5rem';
export const GL_SPACING_SCALE_33 = '16.5rem';
export const GL_SPACING_SCALE_34 = '17rem';
export const GL_SPACING_SCALE_37 = '18.5rem';
export const GL_SPACING_SCALE_48 = '24rem';
export const GL_SPACING_SCALE_62 = '31rem';
export const GL_SPACING_SCALE_75 = '37.5rem';
export const GL_SPACING_SCALE_80 = '40rem';
export const GL_SPACING_SCALE_88 = '44rem';
export const GL_SPACING_SCALE_PX = '1px';
export const GL_SPACING_SCALE_2_5 = '0.375rem';
export const GL_SPACING_SCALE_11_5 = '4.5rem';
export const GL_ZINDEX_0 = '0';
export const GL_ZINDEX_1 = '1';
export const GL_ZINDEX_2 = '2';
export const GL_ZINDEX_3 = '3';
export const GL_ZINDEX_4 = '4';
export const GL_ZINDEX_200 = '200';
export const GL_ZINDEX_9999 = '9999';
export const GL_ALERT_BORDER_RADIUS = '0.5rem';
export const GL_ALERT_NEUTRAL_TITLE_COLOR = '#18171d';
export const GL_ALERT_NEUTRAL_BACKGROUND_COLOR = '#ececef';
export const GL_ALERT_NEUTRAL_BORDER_TOP_COLOR = 'transparent';
export const GL_ALERT_NEUTRAL_BORDER_BOTTOM_COLOR = 'transparent';
export const GL_ALERT_INFO_TITLE_COLOR = '#18171d';
export const GL_ALERT_INFO_BACKGROUND_COLOR = '#e9f3fc';
export const GL_ALERT_INFO_BORDER_TOP_COLOR = 'transparent';
export const GL_ALERT_INFO_BORDER_BOTTOM_COLOR = 'transparent';
export const GL_ALERT_SUCCESS_TITLE_COLOR = '#18171d';
export const GL_ALERT_SUCCESS_BACKGROUND_COLOR = '#ecf4ee';
export const GL_ALERT_SUCCESS_BORDER_TOP_COLOR = 'transparent';
export const GL_ALERT_SUCCESS_BORDER_BOTTOM_COLOR = 'transparent';
export const GL_ALERT_WARNING_TITLE_COLOR = '#18171d';
export const GL_ALERT_WARNING_BACKGROUND_COLOR = '#fdf1dd';
export const GL_ALERT_WARNING_BORDER_TOP_COLOR = 'transparent';
export const GL_ALERT_WARNING_BORDER_BOTTOM_COLOR = 'transparent';
export const GL_ALERT_DANGER_TITLE_COLOR = '#18171d';
export const GL_ALERT_DANGER_BACKGROUND_COLOR = '#fcf1ef';
export const GL_ALERT_DANGER_BORDER_TOP_COLOR = 'transparent';
export const GL_ALERT_DANGER_BORDER_BOTTOM_COLOR = 'transparent';
export const GL_AVATAR_BORDER_COLOR_DEFAULT = 'rgba(05, 05, 06, 0.08)';
export const GL_AVATAR_BORDER_COLOR_HOVER = 'rgba(05, 05, 06, 0.24)';
export const GL_AVATAR_FALLBACK_TEXT_COLOR_RED = '#812713';
export const GL_AVATAR_FALLBACK_TEXT_COLOR_PURPLE = '#493c83';
export const GL_AVATAR_FALLBACK_TEXT_COLOR_BLUE = '#284779';
export const GL_AVATAR_FALLBACK_TEXT_COLOR_GREEN = '#225131';
export const GL_AVATAR_FALLBACK_TEXT_COLOR_ORANGE = '#693c14';
export const GL_AVATAR_FALLBACK_TEXT_COLOR_NEUTRAL = '#3a383f';
export const GL_AVATAR_FALLBACK_BACKGROUND_COLOR_RED = '#fcb5aa3d';
export const GL_AVATAR_FALLBACK_BACKGROUND_COLOR_PURPLE = '#cbbbf23d';
export const GL_AVATAR_FALLBACK_BACKGROUND_COLOR_BLUE = '#9dc7f13d';
export const GL_AVATAR_FALLBACK_BACKGROUND_COLOR_GREEN = '#91d4a83d';
export const GL_AVATAR_FALLBACK_BACKGROUND_COLOR_ORANGE = '#e9be743d';
export const GL_AVATAR_FALLBACK_BACKGROUND_COLOR_NEUTRAL = '#bfbfc33d';
export const GL_BADGE_MUTED_BACKGROUND_COLOR_DEFAULT = '#ececef';
export const GL_BADGE_MUTED_BACKGROUND_COLOR_HOVER = '#ececef';
export const GL_BADGE_MUTED_BACKGROUND_COLOR_FOCUS = '#ececef';
export const GL_BADGE_MUTED_BACKGROUND_COLOR_ACTIVE = '#dcdcde';
export const GL_BADGE_MUTED_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_MUTED_BORDER_COLOR_HOVER = '#bfbfc3';
export const GL_BADGE_MUTED_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_MUTED_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_MUTED_TEXT_COLOR_DEFAULT = '#626168';
export const GL_BADGE_MUTED_TEXT_COLOR_HOVER = '#4c4b51';
export const GL_BADGE_MUTED_TEXT_COLOR_FOCUS = '#4c4b51';
export const GL_BADGE_MUTED_TEXT_COLOR_ACTIVE = '#3a383f';
export const GL_BADGE_MUTED_ICON_COLOR_DEFAULT = '#737278';
export const GL_BADGE_MUTED_ICON_COLOR_HOVER = '#626168';
export const GL_BADGE_MUTED_ICON_COLOR_FOCUS = '#626168';
export const GL_BADGE_MUTED_ICON_COLOR_ACTIVE = '#4c4b51';
export const GL_BADGE_NEUTRAL_BACKGROUND_COLOR_DEFAULT = '#dcdcde';
export const GL_BADGE_NEUTRAL_BACKGROUND_COLOR_HOVER = '#dcdcde';
export const GL_BADGE_NEUTRAL_BACKGROUND_COLOR_FOCUS = '#dcdcde';
export const GL_BADGE_NEUTRAL_BACKGROUND_COLOR_ACTIVE = '#bfbfc3';
export const GL_BADGE_NEUTRAL_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_NEUTRAL_BORDER_COLOR_HOVER = '#bfbfc3';
export const GL_BADGE_NEUTRAL_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_NEUTRAL_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_NEUTRAL_TEXT_COLOR_DEFAULT = '#4c4b51';
export const GL_BADGE_NEUTRAL_TEXT_COLOR_HOVER = '#3a383f';
export const GL_BADGE_NEUTRAL_TEXT_COLOR_FOCUS = '#3a383f';
export const GL_BADGE_NEUTRAL_TEXT_COLOR_ACTIVE = '#28272d';
export const GL_BADGE_NEUTRAL_ICON_COLOR_DEFAULT = '#737278';
export const GL_BADGE_NEUTRAL_ICON_COLOR_HOVER = '#626168';
export const GL_BADGE_NEUTRAL_ICON_COLOR_FOCUS = '#626168';
export const GL_BADGE_NEUTRAL_ICON_COLOR_ACTIVE = '#4c4b51';
export const GL_BADGE_INFO_BACKGROUND_COLOR_DEFAULT = '#cbe2f9';
export const GL_BADGE_INFO_BACKGROUND_COLOR_HOVER = '#cbe2f9';
export const GL_BADGE_INFO_BACKGROUND_COLOR_FOCUS = '#cbe2f9';
export const GL_BADGE_INFO_BACKGROUND_COLOR_ACTIVE = '#9dc7f1';
export const GL_BADGE_INFO_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_INFO_BORDER_COLOR_HOVER = '#9dc7f1';
export const GL_BADGE_INFO_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_INFO_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_INFO_TEXT_COLOR_DEFAULT = '#2f5ca0';
export const GL_BADGE_INFO_TEXT_COLOR_HOVER = '#284779';
export const GL_BADGE_INFO_TEXT_COLOR_FOCUS = '#284779';
export const GL_BADGE_INFO_TEXT_COLOR_ACTIVE = '#213454';
export const GL_BADGE_INFO_ICON_COLOR_DEFAULT = '#1f75cb';
export const GL_BADGE_INFO_ICON_COLOR_HOVER = '#2f68b4';
export const GL_BADGE_INFO_ICON_COLOR_FOCUS = '#2f68b4';
export const GL_BADGE_INFO_ICON_COLOR_ACTIVE = '#2f5ca0';
export const GL_BADGE_SUCCESS_BACKGROUND_COLOR_DEFAULT = '#c3e6cd';
export const GL_BADGE_SUCCESS_BACKGROUND_COLOR_HOVER = '#c3e6cd';
export const GL_BADGE_SUCCESS_BACKGROUND_COLOR_FOCUS = '#c3e6cd';
export const GL_BADGE_SUCCESS_BACKGROUND_COLOR_ACTIVE = '#91d4a8';
export const GL_BADGE_SUCCESS_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_SUCCESS_BORDER_COLOR_HOVER = '#91d4a8';
export const GL_BADGE_SUCCESS_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_SUCCESS_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_SUCCESS_TEXT_COLOR_DEFAULT = '#306440';
export const GL_BADGE_SUCCESS_TEXT_COLOR_HOVER = '#225131';
export const GL_BADGE_SUCCESS_TEXT_COLOR_FOCUS = '#225131';
export const GL_BADGE_SUCCESS_TEXT_COLOR_ACTIVE = '#1e3e28';
export const GL_BADGE_SUCCESS_ICON_COLOR_DEFAULT = '#108548';
export const GL_BADGE_SUCCESS_ICON_COLOR_HOVER = '#2f7549';
export const GL_BADGE_SUCCESS_ICON_COLOR_FOCUS = '#2f7549';
export const GL_BADGE_SUCCESS_ICON_COLOR_ACTIVE = '#306440';
export const GL_BADGE_WARNING_BACKGROUND_COLOR_DEFAULT = '#f5d9a8';
export const GL_BADGE_WARNING_BACKGROUND_COLOR_HOVER = '#f5d9a8';
export const GL_BADGE_WARNING_BACKGROUND_COLOR_FOCUS = '#f5d9a8';
export const GL_BADGE_WARNING_BACKGROUND_COLOR_ACTIVE = '#e9be74';
export const GL_BADGE_WARNING_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_WARNING_BORDER_COLOR_HOVER = '#e9be74';
export const GL_BADGE_WARNING_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_WARNING_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_WARNING_TEXT_COLOR_DEFAULT = '#894b16';
export const GL_BADGE_WARNING_TEXT_COLOR_HOVER = '#693c14';
export const GL_BADGE_WARNING_TEXT_COLOR_FOCUS = '#693c14';
export const GL_BADGE_WARNING_TEXT_COLOR_ACTIVE = '#532e16';
export const GL_BADGE_WARNING_ICON_COLOR_DEFAULT = '#ab6100';
export const GL_BADGE_WARNING_ICON_COLOR_HOVER = '#995715';
export const GL_BADGE_WARNING_ICON_COLOR_FOCUS = '#995715';
export const GL_BADGE_WARNING_ICON_COLOR_ACTIVE = '#894b16';
export const GL_BADGE_DANGER_BACKGROUND_COLOR_DEFAULT = '#fdd4cd';
export const GL_BADGE_DANGER_BACKGROUND_COLOR_HOVER = '#fdd4cd';
export const GL_BADGE_DANGER_BACKGROUND_COLOR_FOCUS = '#fdd4cd';
export const GL_BADGE_DANGER_BACKGROUND_COLOR_ACTIVE = '#fcb5aa';
export const GL_BADGE_DANGER_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_DANGER_BORDER_COLOR_HOVER = '#fcb5aa';
export const GL_BADGE_DANGER_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_DANGER_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_DANGER_TEXT_COLOR_DEFAULT = '#a32c12';
export const GL_BADGE_DANGER_TEXT_COLOR_HOVER = '#812713';
export const GL_BADGE_DANGER_TEXT_COLOR_FOCUS = '#812713';
export const GL_BADGE_DANGER_TEXT_COLOR_ACTIVE = '#582014';
export const GL_BADGE_DANGER_ICON_COLOR_DEFAULT = '#a32c12';
export const GL_BADGE_DANGER_ICON_COLOR_HOVER = '#812713';
export const GL_BADGE_DANGER_ICON_COLOR_FOCUS = '#812713';
export const GL_BADGE_DANGER_ICON_COLOR_ACTIVE = '#582014';
export const GL_BADGE_TIER_BACKGROUND_COLOR_DEFAULT = '#e1d8f9';
export const GL_BADGE_TIER_BACKGROUND_COLOR_HOVER = '#e1d8f9';
export const GL_BADGE_TIER_BACKGROUND_COLOR_FOCUS = '#e1d8f9';
export const GL_BADGE_TIER_BACKGROUND_COLOR_ACTIVE = '#cbbbf2';
export const GL_BADGE_TIER_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BADGE_TIER_BORDER_COLOR_HOVER = '#cbbbf2';
export const GL_BADGE_TIER_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BADGE_TIER_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BADGE_TIER_TEXT_COLOR_DEFAULT = '#5c47a6';
export const GL_BADGE_TIER_TEXT_COLOR_HOVER = '#493c83';
export const GL_BADGE_TIER_TEXT_COLOR_FOCUS = '#493c83';
export const GL_BADGE_TIER_TEXT_COLOR_ACTIVE = '#342d59';
export const GL_BADGE_TIER_ICON_COLOR_DEFAULT = '#5c47a6';
export const GL_BADGE_TIER_ICON_COLOR_HOVER = '#493c83';
export const GL_BADGE_TIER_ICON_COLOR_FOCUS = '#493c83';
export const GL_BADGE_TIER_ICON_COLOR_ACTIVE = '#342d59';
export const GL_BANNER_INTRO_BORDER_COLOR = '#9dc7f1';
export const GL_BANNER_PROMO_BACKGROUND_COLOR = '#f4f0ff';
export const GL_BANNER_PROMO_BORDER_COLOR = '#cbbbf2';
export const GL_BREADCRUMB_SEPARATOR_COLOR = '#89888d';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_BLUE = '#235180';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_DARK = '#737278';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_GREEN = '#1b653f';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_INDIGO = '#41419f';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_LIGHT = '#ececef';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_LIGHTBLUE = '#4977a5';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_LIGHTGREEN = '#308258';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_LIGHTINDIGO = '#6666c4';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_LIGHTRED = '#ad4a3b';
export const GL_BROADCAST_BANNER_BACKGROUND_COLOR_RED = '#8f2110';
export const GL_BROADCAST_BANNER_BORDER_COLOR_BLUE = '#0b2640';
export const GL_BROADCAST_BANNER_BORDER_COLOR_DARK = '#4c4b51';
export const GL_BROADCAST_BANNER_BORDER_COLOR_GREEN = '#0e4328';
export const GL_BROADCAST_BANNER_BORDER_COLOR_INDIGO = '#222261';
export const GL_BROADCAST_BANNER_BORDER_COLOR_LIGHT = '#dcdcde';
export const GL_BROADCAST_BANNER_BORDER_COLOR_LIGHTBLUE = '#235180';
export const GL_BROADCAST_BANNER_BORDER_COLOR_LIGHTGREEN = '#1b653f';
export const GL_BROADCAST_BANNER_BORDER_COLOR_LIGHTINDIGO = '#41419f';
export const GL_BROADCAST_BANNER_BORDER_COLOR_LIGHTRED = '#8f2110';
export const GL_BROADCAST_BANNER_BORDER_COLOR_RED = '#580d02';
export const GL_BROADCAST_BANNER_BORDER_RADIUS = '0.25rem';
export const GL_BROADCAST_BANNER_ICON_COLOR_BLUE = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_DARK = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_GREEN = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_INDIGO = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_LIGHT = '#28272d';
export const GL_BROADCAST_BANNER_ICON_COLOR_LIGHTBLUE = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_LIGHTGREEN = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_LIGHTINDIGO = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_LIGHTRED = '#fff';
export const GL_BROADCAST_BANNER_ICON_COLOR_RED = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_BLUE = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_DARK = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_GREEN = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_INDIGO = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_LIGHT = '#28272d';
export const GL_BROADCAST_BANNER_TEXT_COLOR_LIGHTBLUE = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_LIGHTGREEN = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_LIGHTINDIGO = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_LIGHTRED = '#fff';
export const GL_BROADCAST_BANNER_TEXT_COLOR_RED = '#fff';
export const GL_BUTTON_BORDER_RADIUS = '0.5rem';
export const GL_BUTTON_DEFAULT_PRIMARY_FOREGROUND_COLOR_DEFAULT = '#3a383f';
export const GL_BUTTON_DEFAULT_PRIMARY_FOREGROUND_COLOR_HOVER = '#3a383f';
export const GL_BUTTON_DEFAULT_PRIMARY_FOREGROUND_COLOR_FOCUS = '#3a383f';
export const GL_BUTTON_DEFAULT_PRIMARY_FOREGROUND_COLOR_ACTIVE = '#3a383f';
export const GL_BUTTON_DEFAULT_PRIMARY_BACKGROUND_COLOR_DEFAULT = '#fff';
export const GL_BUTTON_DEFAULT_PRIMARY_BACKGROUND_COLOR_HOVER = '#ececef';
export const GL_BUTTON_DEFAULT_PRIMARY_BACKGROUND_COLOR_FOCUS = '#ececef';
export const GL_BUTTON_DEFAULT_PRIMARY_BACKGROUND_COLOR_ACTIVE = '#dcdcde';
export const GL_BUTTON_DEFAULT_PRIMARY_BORDER_COLOR_DEFAULT = '#bfbfc3';
export const GL_BUTTON_DEFAULT_PRIMARY_BORDER_COLOR_HOVER = '#89888d';
export const GL_BUTTON_DEFAULT_PRIMARY_BORDER_COLOR_FOCUS = '#89888d';
export const GL_BUTTON_DEFAULT_PRIMARY_BORDER_COLOR_ACTIVE = '#626168';
export const GL_BUTTON_DEFAULT_TERTIARY_FOREGROUND_COLOR_DEFAULT = '#28272d';
export const GL_BUTTON_DEFAULT_TERTIARY_FOREGROUND_COLOR_HOVER = '#28272d';
export const GL_BUTTON_DEFAULT_TERTIARY_FOREGROUND_COLOR_FOCUS = '#28272d';
export const GL_BUTTON_DEFAULT_TERTIARY_FOREGROUND_COLOR_ACTIVE = '#28272d';
export const GL_BUTTON_DEFAULT_TERTIARY_BACKGROUND_COLOR_DEFAULT = 'rgba(164, 163, 168, 0.0)';
export const GL_BUTTON_DEFAULT_TERTIARY_BACKGROUND_COLOR_HOVER = 'rgba(164, 163, 168, 0.16)';
export const GL_BUTTON_DEFAULT_TERTIARY_BACKGROUND_COLOR_FOCUS = 'rgba(164, 163, 168, 0.16)';
export const GL_BUTTON_DEFAULT_TERTIARY_BACKGROUND_COLOR_ACTIVE = 'rgba(83, 81, 88, 0.24)';
export const GL_BUTTON_DEFAULT_TERTIARY_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BUTTON_DEFAULT_TERTIARY_BORDER_COLOR_HOVER = 'transparent';
export const GL_BUTTON_DEFAULT_TERTIARY_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BUTTON_DEFAULT_TERTIARY_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BUTTON_CONFIRM_PRIMARY_FOREGROUND_COLOR_DEFAULT = '#fff';
export const GL_BUTTON_CONFIRM_PRIMARY_FOREGROUND_COLOR_HOVER = '#fff';
export const GL_BUTTON_CONFIRM_PRIMARY_FOREGROUND_COLOR_FOCUS = '#fff';
export const GL_BUTTON_CONFIRM_PRIMARY_FOREGROUND_COLOR_ACTIVE = '#fff';
export const GL_BUTTON_CONFIRM_PRIMARY_BACKGROUND_COLOR_DEFAULT = '#1f75cb';
export const GL_BUTTON_CONFIRM_PRIMARY_BACKGROUND_COLOR_HOVER = '#2f68b4';
export const GL_BUTTON_CONFIRM_PRIMARY_BACKGROUND_COLOR_FOCUS = '#2f68b4';
export const GL_BUTTON_CONFIRM_PRIMARY_BACKGROUND_COLOR_ACTIVE = '#2f5ca0';
export const GL_BUTTON_CONFIRM_PRIMARY_BORDER_COLOR_DEFAULT = '#2f68b4';
export const GL_BUTTON_CONFIRM_PRIMARY_BORDER_COLOR_HOVER = '#284779';
export const GL_BUTTON_CONFIRM_PRIMARY_BORDER_COLOR_FOCUS = '#284779';
export const GL_BUTTON_CONFIRM_PRIMARY_BORDER_COLOR_ACTIVE = '#213454';
export const GL_BUTTON_CONFIRM_SECONDARY_FOREGROUND_COLOR_DEFAULT = '#1f75cb';
export const GL_BUTTON_CONFIRM_SECONDARY_FOREGROUND_COLOR_HOVER = '#2f5ca0';
export const GL_BUTTON_CONFIRM_SECONDARY_FOREGROUND_COLOR_FOCUS = '#2f5ca0';
export const GL_BUTTON_CONFIRM_SECONDARY_FOREGROUND_COLOR_ACTIVE = '#213454';
export const GL_BUTTON_CONFIRM_SECONDARY_BACKGROUND_COLOR_DEFAULT = '#fff';
export const GL_BUTTON_CONFIRM_SECONDARY_BACKGROUND_COLOR_HOVER = '#e9f3fc';
export const GL_BUTTON_CONFIRM_SECONDARY_BACKGROUND_COLOR_FOCUS = '#e9f3fc';
export const GL_BUTTON_CONFIRM_SECONDARY_BACKGROUND_COLOR_ACTIVE = '#cbe2f9';
export const GL_BUTTON_CONFIRM_SECONDARY_BORDER_COLOR_DEFAULT = '#1f75cb';
export const GL_BUTTON_CONFIRM_SECONDARY_BORDER_COLOR_HOVER = '#2f5ca0';
export const GL_BUTTON_CONFIRM_SECONDARY_BORDER_COLOR_FOCUS = '#2f5ca0';
export const GL_BUTTON_CONFIRM_SECONDARY_BORDER_COLOR_ACTIVE = '#213454';
export const GL_BUTTON_CONFIRM_TERTIARY_FOREGROUND_COLOR_DEFAULT = '#1f75cb';
export const GL_BUTTON_CONFIRM_TERTIARY_FOREGROUND_COLOR_HOVER = '#2f5ca0';
export const GL_BUTTON_CONFIRM_TERTIARY_FOREGROUND_COLOR_FOCUS = '#2f5ca0';
export const GL_BUTTON_CONFIRM_TERTIARY_FOREGROUND_COLOR_ACTIVE = '#213454';
export const GL_BUTTON_CONFIRM_TERTIARY_BACKGROUND_COLOR_DEFAULT = 'rgba(99, 166, 233, 0.0)';
export const GL_BUTTON_CONFIRM_TERTIARY_BACKGROUND_COLOR_HOVER = 'rgba(99, 166, 233, 0.16)';
export const GL_BUTTON_CONFIRM_TERTIARY_BACKGROUND_COLOR_FOCUS = 'rgba(99, 166, 233, 0.16)';
export const GL_BUTTON_CONFIRM_TERTIARY_BACKGROUND_COLOR_ACTIVE = 'rgba(11, 92, 173, 0.24)';
export const GL_BUTTON_CONFIRM_TERTIARY_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BUTTON_CONFIRM_TERTIARY_BORDER_COLOR_HOVER = 'transparent';
export const GL_BUTTON_CONFIRM_TERTIARY_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BUTTON_CONFIRM_TERTIARY_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BUTTON_DANGER_PRIMARY_FOREGROUND_COLOR_DEFAULT = '#fff';
export const GL_BUTTON_DANGER_PRIMARY_FOREGROUND_COLOR_HOVER = '#fff';
export const GL_BUTTON_DANGER_PRIMARY_FOREGROUND_COLOR_FOCUS = '#fff';
export const GL_BUTTON_DANGER_PRIMARY_FOREGROUND_COLOR_ACTIVE = '#fff';
export const GL_BUTTON_DANGER_PRIMARY_BACKGROUND_COLOR_DEFAULT = '#dd2b0e';
export const GL_BUTTON_DANGER_PRIMARY_BACKGROUND_COLOR_HOVER = '#c02f12';
export const GL_BUTTON_DANGER_PRIMARY_BACKGROUND_COLOR_FOCUS = '#c02f12';
export const GL_BUTTON_DANGER_PRIMARY_BACKGROUND_COLOR_ACTIVE = '#812713';
export const GL_BUTTON_DANGER_PRIMARY_BORDER_COLOR_DEFAULT = '#c02f12';
export const GL_BUTTON_DANGER_PRIMARY_BORDER_COLOR_HOVER = '#812713';
export const GL_BUTTON_DANGER_PRIMARY_BORDER_COLOR_FOCUS = '#812713';
export const GL_BUTTON_DANGER_PRIMARY_BORDER_COLOR_ACTIVE = '#582014';
export const GL_BUTTON_DANGER_SECONDARY_FOREGROUND_COLOR_DEFAULT = '#dd2b0e';
export const GL_BUTTON_DANGER_SECONDARY_FOREGROUND_COLOR_HOVER = '#a32c12';
export const GL_BUTTON_DANGER_SECONDARY_FOREGROUND_COLOR_FOCUS = '#a32c12';
export const GL_BUTTON_DANGER_SECONDARY_FOREGROUND_COLOR_ACTIVE = '#582014';
export const GL_BUTTON_DANGER_SECONDARY_BACKGROUND_COLOR_DEFAULT = '#fff';
export const GL_BUTTON_DANGER_SECONDARY_BACKGROUND_COLOR_HOVER = '#fcf1ef';
export const GL_BUTTON_DANGER_SECONDARY_BACKGROUND_COLOR_FOCUS = '#fcf1ef';
export const GL_BUTTON_DANGER_SECONDARY_BACKGROUND_COLOR_ACTIVE = '#fdd4cd';
export const GL_BUTTON_DANGER_SECONDARY_BORDER_COLOR_DEFAULT = '#dd2b0e';
export const GL_BUTTON_DANGER_SECONDARY_BORDER_COLOR_HOVER = '#a32c12';
export const GL_BUTTON_DANGER_SECONDARY_BORDER_COLOR_FOCUS = '#a32c12';
export const GL_BUTTON_DANGER_SECONDARY_BORDER_COLOR_ACTIVE = '#582014';
export const GL_BUTTON_DANGER_TERTIARY_FOREGROUND_COLOR_DEFAULT = '#dd2b0e';
export const GL_BUTTON_DANGER_TERTIARY_FOREGROUND_COLOR_HOVER = '#a32c12';
export const GL_BUTTON_DANGER_TERTIARY_FOREGROUND_COLOR_FOCUS = '#a32c12';
export const GL_BUTTON_DANGER_TERTIARY_FOREGROUND_COLOR_ACTIVE = '#582014';
export const GL_BUTTON_DANGER_TERTIARY_BACKGROUND_COLOR_DEFAULT = 'rgba(245, 127, 108, 0.0)';
export const GL_BUTTON_DANGER_TERTIARY_BACKGROUND_COLOR_HOVER = 'rgba(245, 127, 108, 0.16)';
export const GL_BUTTON_DANGER_TERTIARY_BACKGROUND_COLOR_FOCUS = 'rgba(245, 127, 108, 0.16)';
export const GL_BUTTON_DANGER_TERTIARY_BACKGROUND_COLOR_ACTIVE = 'rgba(174, 24, 0, 0.24)';
export const GL_BUTTON_DANGER_TERTIARY_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_BUTTON_DANGER_TERTIARY_BORDER_COLOR_HOVER = 'transparent';
export const GL_BUTTON_DANGER_TERTIARY_BORDER_COLOR_FOCUS = 'transparent';
export const GL_BUTTON_DANGER_TERTIARY_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BUTTON_DASHED_BORDER_COLOR_DEFAULT = '#89888d';
export const GL_BUTTON_DASHED_BORDER_COLOR_HOVER = '#89888d';
export const GL_BUTTON_DASHED_BORDER_COLOR_FOCUS = '#89888d';
export const GL_BUTTON_DASHED_BORDER_COLOR_ACTIVE = '#626168';
export const GL_BUTTON_LINK_BORDER_RADIUS = '0.25rem';
export const GL_BUTTON_LINK_TEXT_COLOR_DEFAULT = '#2f5ca0';
export const GL_BUTTON_LINK_TEXT_COLOR_HOVER = '#2f5ca0';
export const GL_BUTTON_LINK_TEXT_COLOR_FOCUS = '#2f5ca0';
export const GL_BUTTON_LINK_TEXT_COLOR_ACTIVE = '#2f5ca0';
export const GL_BUTTON_SELECTED_FOREGROUND_COLOR_DEFAULT = '#3a383f';
export const GL_BUTTON_SELECTED_FOREGROUND_COLOR_HOVER = '#3a383f';
export const GL_BUTTON_SELECTED_FOREGROUND_COLOR_FOCUS = '#3a383f';
export const GL_BUTTON_SELECTED_FOREGROUND_COLOR_ACTIVE = '#3a383f';
export const GL_BUTTON_SELECTED_BACKGROUND_COLOR_DEFAULT = '#ececef';
export const GL_BUTTON_SELECTED_BACKGROUND_COLOR_HOVER = '#ececef';
export const GL_BUTTON_SELECTED_BACKGROUND_COLOR_FOCUS = '#ececef';
export const GL_BUTTON_SELECTED_BACKGROUND_COLOR_ACTIVE = '#dcdcde';
export const GL_BUTTON_SELECTED_BORDER_COLOR_DEFAULT = '#a4a3a8';
export const GL_BUTTON_SELECTED_BORDER_COLOR_HOVER = '#89888d';
export const GL_BUTTON_SELECTED_BORDER_COLOR_FOCUS = '#89888d';
export const GL_BUTTON_SELECTED_BORDER_COLOR_ACTIVE = '#626168';
export const GL_BUTTON_DISABLED_FOREGROUND_COLOR = '#737278';
export const GL_BUTTON_DISABLED_BACKGROUND_COLOR = '#fbfafd';
export const GL_BUTTON_DISABLED_BORDER_COLOR = '#dcdcde';
export const GL_BUTTON_COUNT_BACKGROUND_COLOR = 'rgba(05, 05, 06, 0.08)';
export const GL_CARD_BORDER_RADIUS = '0.5rem';
export const GL_CHART_AXIS_POINTER_COLOR = '#626168';
export const GL_CHART_AXIS_LINE_COLOR = '#bfbfc3';
export const GL_CHART_AXIS_TEXT_COLOR = '#626168';
export const GL_CHART_THRESHOLD_AREA_COLOR = 'rgba(221,43,14,0.1)';
export const GL_CHART_THRESHOLD_LINE_COLOR = '#dd2b0e';
export const GL_CHART_ZOOM_FILLER_COLOR = 'rgba(05, 05, 06, 0.08)';
export const GL_CHART_ZOOM_HANDLE_COLOR = '#626168';
export const GL_DATEPICKER_BACKGROUND_COLOR = '#fff';
export const GL_DATEPICKER_DATE_TEXT_COLOR_SELECTED = '#fff';
export const GL_DROPDOWN_BACKGROUND_COLOR = '#fff';
export const GL_DROPDOWN_BORDER_COLOR = '#bfbfc3';
export const GL_DROPDOWN_BORDER_RADIUS = '0.5rem';
export const GL_DROPDOWN_DIVIDER_COLOR = '#dcdcde';
export const GL_DROPDOWN_OPTION_TEXT_COLOR_DEFAULT = '#28272d';
export const GL_DROPDOWN_OPTION_TEXT_COLOR_HOVER = '#28272d';
export const GL_DROPDOWN_OPTION_TEXT_COLOR_FOCUS = '#28272d';
export const GL_DROPDOWN_OPTION_TEXT_COLOR_ACTIVE = '#28272d';
export const GL_DROPDOWN_OPTION_TEXT_COLOR_DISABLED = '#89888d';
export const GL_DROPDOWN_OPTION_INDICATOR_COLOR_SELECTED_DEFAULT = '#1f75cb';
export const GL_DROPDOWN_OPTION_INDICATOR_COLOR_SELECTED_HOVER = '#2f5ca0';
export const GL_DROPDOWN_OPTION_INDICATOR_COLOR_SELECTED_FOCUS = '#2f5ca0';
export const GL_DROPDOWN_OPTION_INDICATOR_COLOR_SELECTED_ACTIVE = '#2f5ca0';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_UNSELECTED_DEFAULT = 'rgba(164, 163, 168, 0.0)';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_UNSELECTED_HOVER = 'rgba(164, 163, 168, 0.16)';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_UNSELECTED_FOCUS = 'rgba(164, 163, 168, 0.16)';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_UNSELECTED_ACTIVE = 'rgba(83, 81, 88, 0.24)';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_SELECTED_DEFAULT = '#ececef';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_SELECTED_HOVER = '#dcdcde';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_SELECTED_FOCUS = '#dcdcde';
export const GL_DROPDOWN_OPTION_BACKGROUND_COLOR_SELECTED_ACTIVE = '#bfbfc3';
export const GL_DROPDOWN_SEARCH_BACKGROUND_COLOR = 'rgba(05, 05, 06, 0.02)';
export const GL_FILTERED_SEARCH_TOKEN_TYPE_BACKGROUND_COLOR_DEFAULT = '#ececef';
export const GL_FILTERED_SEARCH_TOKEN_TYPE_BACKGROUND_COLOR_HOVER = '#dcdcde';
export const GL_FILTERED_SEARCH_TOKEN_DATA_BACKGROUND_COLOR_DEFAULT = '#dcdcde';
export const GL_FILTERED_SEARCH_TOKEN_DATA_BACKGROUND_COLOR_HOVER = '#bfbfc3';
export const GL_FILTERED_SEARCH_TOKEN_OPERATOR_BACKGROUND_COLOR_DEFAULT = '#ececef';
export const GL_FILTERED_SEARCH_TOKEN_OPERATOR_BACKGROUND_COLOR_HOVER = '#dcdcde';
export const GL_ILLUSTRATION_STROKE_COLOR_DEFAULT = '#171321';
export const GL_ILLUSTRATION_STROKE_WIDTH_DEFAULT = '2';
export const GL_ILLUSTRATION_FILL_COLOR_DEFAULT = '#fff';
export const GL_ILLUSTRATION_STATUS_FILL_COLOR_NEUTRAL = '#aea5d6';
export const GL_ILLUSTRATION_STATUS_FILL_COLOR_SUCCESS = '#6fdac9';
export const GL_ILLUSTRATION_STATUS_FILL_COLOR_WARNING = '#fca326';
export const GL_ILLUSTRATION_STATUS_FILL_COLOR_DANGER = '#ff9d73';
export const GL_ILLUSTRATION_ACCENT_STROKE_COLOR_ORANGE = '#ff9d73';
export const GL_ILLUSTRATION_ACCENT_STROKE_COLOR_TEAL = '#6fdac9';
export const GL_ILLUSTRATION_ACCENT_STROKE_COLOR_STRONG = '#aea5d6';
export const GL_ILLUSTRATION_ACCENT_FILL_COLOR_SUBTLE = '#d0c5e2';
export const GL_ILLUSTRATION_ACCENT_FILL_COLOR_STRONG = '#aea5d6';
export const GL_ILLUSTRATION_ACCENT_FILL_COLOR_ORANGE = '#ff9d73';
export const GL_ILLUSTRATION_ACCENT_FILL_COLOR_TEAL = '#6fdac9';
export const GL_ILLUSTRATION_BASE_FILL_COLOR = '#e7e4f2';
export const GL_ILLUSTRATION_ISOMETRIC_STROKE_COLOR_DEFAULT = '#171321';
export const GL_ILLUSTRATION_ISOMETRIC_STROKE_WIDTH_DEFAULT = '2';
export const GL_ILLUSTRATION_ISOMETRIC_GLYPH_TOP_FILL_COLOR = '#c5f4ec';
export const GL_ILLUSTRATION_ISOMETRIC_GLYPH_FRONT_FILL_COLOR = '#fff';
export const GL_ILLUSTRATION_ISOMETRIC_GLYPH_SIDE_FILL_COLOR = '#6fdac9';
export const GL_ILLUSTRATION_ISOMETRIC_GLYPH_SHADOW_FILL_COLOR = '#10b1b1';
export const GL_ILLUSTRATION_ISOMETRIC_OBJECT_TOP_FILL_COLOR = '#ff9d73';
export const GL_ILLUSTRATION_ISOMETRIC_OBJECT_FRONT_FILL_COLOR = '#ffc2a8';
export const GL_ILLUSTRATION_ISOMETRIC_OBJECT_SIDE_FILL_COLOR = '#ff7b42';
export const GL_ILLUSTRATION_ISOMETRIC_OBJECT_HIGHLIGHT_FILL_COLOR = '#fff';
export const GL_ILLUSTRATION_ISOMETRIC_OBJECT_SHADOW_FILL_COLOR = '#e24329';
export const GL_ILLUSTRATION_ISOMETRIC_ACCENT_TOP_FILL_COLOR = '#45424d';
export const GL_ILLUSTRATION_ISOMETRIC_ACCENT_FRONT_FILL_COLOR = '#74717a';
export const GL_ILLUSTRATION_ISOMETRIC_ACCENT_SIDE_FILL_COLOR = '#2b2838';
export const GL_ILLUSTRATION_ISOMETRIC_BASE_TOP_FILL_COLOR = '#e7e4f2';
export const GL_ILLUSTRATION_ISOMETRIC_BASE_FRONT_FILL_COLOR = '#d5d0e8';
export const GL_ILLUSTRATION_ISOMETRIC_BASE_SIDE_FILL_COLOR = '#aea5d6';
export const GL_LABEL_LIGHT_TEXT_COLOR = '#18171d';
export const GL_LABEL_LIGHT_BUTTON_BACKGROUND_COLOR_DEFAULT = 'transparent';
export const GL_LABEL_LIGHT_BUTTON_BACKGROUND_COLOR_HOVER = '#18171d';
export const GL_LABEL_LIGHT_BUTTON_ICON_COLOR_DEFAULT = '#18171d';
export const GL_LABEL_DARK_TEXT_COLOR = '#fff';
export const GL_LABEL_DARK_BUTTON_BACKGROUND_COLOR_DEFAULT = 'transparent';
export const GL_LABEL_DARK_BUTTON_BACKGROUND_COLOR_HOVER = '#fff';
export const GL_LABEL_DARK_BUTTON_ICON_COLOR_DEFAULT = '#fff';
export const GL_LABEL_SCOPED_TEXT_COLOR = '#18171d';
export const GL_LABEL_SCOPED_BUTTON_BACKGROUND_COLOR_HOVER = '#18171d';
export const GL_LABEL_SCOPED_BUTTON_ICON_COLOR_DEFAULT = '#18171d';
export const GL_LABEL_SCOPED_BUTTON_ICON_COLOR_HOVER = '#fff';
export const GL_LINK_MENTION_TEXT_COLOR_DEFAULT = '#284779';
export const GL_LINK_MENTION_TEXT_COLOR_CURRENT = '#693c14';
export const GL_LINK_MENTION_BACKGROUND_COLOR_DEFAULT = '#cbe2f9';
export const GL_LINK_MENTION_BACKGROUND_COLOR_CURRENT = '#f5d9a8';
export const GL_MODAL_BORDER_RADIUS = '0.5rem';
export const GL_PROGRESS_BAR_INDICATOR_COLOR_DEFAULT = '#1f75cb';
export const GL_PROGRESS_BAR_INDICATOR_COLOR_SUCCESS = '#108548';
export const GL_PROGRESS_BAR_INDICATOR_COLOR_WARNING = '#ab6100';
export const GL_PROGRESS_BAR_INDICATOR_COLOR_DANGER = '#dd2b0e';
export const GL_PROGRESS_BAR_TRACK_COLOR = '#bfbfc3';
export const GL_SKELETON_LOADER_BACKGROUND_COLOR = '#dcdcde';
export const GL_SKELETON_LOADER_SHIMMER_COLOR = '#ececef';
export const GL_SPINNER_TRACK_COLOR_DEFAULT = '#dcdcde';
export const GL_SPINNER_TRACK_COLOR_LIGHT = '#3a383f';
export const GL_SPINNER_SEGMENT_COLOR_DEFAULT = '#4c4b51';
export const GL_SPINNER_SEGMENT_COLOR_LIGHT = '#bfbfc3';
export const GL_TABLE_ROW_BACKGROUND_COLOR_HOVER = '#e9f3fc';
export const GL_TABLE_SORTING_ICON_COLOR = '#18171d';
export const GL_TAB_SELECTED_INDICATOR_COLOR_DEFAULT = '#1f75cb';
export const GL_TOGGLE_SWITCH_ICON_COLOR_UNCHECKED_DEFAULT = '#626168';
export const GL_TOGGLE_SWITCH_ICON_COLOR_UNCHECKED_HOVER = '#4c4b51';
export const GL_TOGGLE_SWITCH_ICON_COLOR_UNCHECKED_FOCUS = '#4c4b51';
export const GL_TOGGLE_SWITCH_ICON_COLOR_UNCHECKED_ACTIVE = '#3a383f';
export const GL_TOGGLE_SWITCH_ICON_COLOR_CHECKED_DEFAULT = '#1f75cb';
export const GL_TOGGLE_SWITCH_ICON_COLOR_CHECKED_HOVER = '#2f68b4';
export const GL_TOGGLE_SWITCH_ICON_COLOR_CHECKED_FOCUS = '#2f68b4';
export const GL_TOGGLE_SWITCH_ICON_COLOR_CHECKED_ACTIVE = '#2f5ca0';
export const GL_TOGGLE_SWITCH_ICON_COLOR_DISABLED = '#ececef';
export const GL_TOKEN_SELECTOR_TOKEN_CONTAINER_TOKEN_BACKGROUND_COLOR_FOCUS = '#a4a3a8';
export const GL_TOKEN_BORDER_RADIUS = '0.25rem';
export const GL_TOKEN_FOREGROUND_COLOR = '#3a383f';
export const GL_TOKEN_BACKGROUND_COLOR = '#dcdcde';
export const DATA_VIZ_GREEN_50 = '#ddfab7';
export const DATA_VIZ_GREEN_100 = '#c6ed94';
export const DATA_VIZ_GREEN_200 = '#b0d97b';
export const DATA_VIZ_GREEN_300 = '#94c25e';
export const DATA_VIZ_GREEN_400 = '#81ac41';
export const DATA_VIZ_GREEN_500 = '#619025';
export const DATA_VIZ_GREEN_600 = '#4e7f0e';
export const DATA_VIZ_GREEN_700 = '#366800';
export const DATA_VIZ_GREEN_800 = '#275600';
export const DATA_VIZ_GREEN_900 = '#1a4500';
export const DATA_VIZ_GREEN_950 = '#133a03';
export const DATA_VIZ_AQUA_50 = '#b5fefd';
export const DATA_VIZ_AQUA_100 = '#93f2ef';
export const DATA_VIZ_AQUA_200 = '#5edee3';
export const DATA_VIZ_AQUA_300 = '#32c5d2';
export const DATA_VIZ_AQUA_400 = '#00acc4';
export const DATA_VIZ_AQUA_500 = '#0090b1';
export const DATA_VIZ_AQUA_600 = '#007b9b';
export const DATA_VIZ_AQUA_700 = '#006381';
export const DATA_VIZ_AQUA_800 = '#00516c';
export const DATA_VIZ_AQUA_900 = '#004059';
export const DATA_VIZ_AQUA_950 = '#00344b';
export const DATA_VIZ_BLUE_50 = '#e9ebff';
export const DATA_VIZ_BLUE_100 = '#d2dcff';
export const DATA_VIZ_BLUE_200 = '#b7c6ff';
export const DATA_VIZ_BLUE_300 = '#97acff';
export const DATA_VIZ_BLUE_400 = '#7992f5';
export const DATA_VIZ_BLUE_500 = '#617ae2';
export const DATA_VIZ_BLUE_600 = '#4e65cd';
export const DATA_VIZ_BLUE_700 = '#3f51ae';
export const DATA_VIZ_BLUE_800 = '#374291';
export const DATA_VIZ_BLUE_900 = '#303470';
export const DATA_VIZ_BLUE_950 = '#2a2b59';
export const DATA_VIZ_MAGENTA_50 = '#ffe3eb';
export const DATA_VIZ_MAGENTA_100 = '#ffccdb';
export const DATA_VIZ_MAGENTA_200 = '#fcacc5';
export const DATA_VIZ_MAGENTA_300 = '#f88aaf';
export const DATA_VIZ_MAGENTA_400 = '#e86e9a';
export const DATA_VIZ_MAGENTA_500 = '#cf4d81';
export const DATA_VIZ_MAGENTA_600 = '#b93d71';
export const DATA_VIZ_MAGENTA_700 = '#9a2e5d';
export const DATA_VIZ_MAGENTA_800 = '#7c214f';
export const DATA_VIZ_MAGENTA_900 = '#661e3a';
export const DATA_VIZ_MAGENTA_950 = '#541d31';
export const DATA_VIZ_ORANGE_50 = '#fae8d1';
export const DATA_VIZ_ORANGE_100 = '#f5d6b3';
export const DATA_VIZ_ORANGE_200 = '#eebd8c';
export const DATA_VIZ_ORANGE_300 = '#e99b60';
export const DATA_VIZ_ORANGE_400 = '#e07e41';
export const DATA_VIZ_ORANGE_500 = '#c95d2e';
export const DATA_VIZ_ORANGE_600 = '#b14f18';
export const DATA_VIZ_ORANGE_700 = '#92430a';
export const DATA_VIZ_ORANGE_800 = '#6f3500';
export const DATA_VIZ_ORANGE_900 = '#5e2f05';
export const DATA_VIZ_ORANGE_950 = '#4b2707';
export const THEME_INDIGO_10 = '#f8f8ff';
export const THEME_INDIGO_50 = '#f1f1ff';
export const THEME_INDIGO_100 = '#dbdbf8';
export const THEME_INDIGO_200 = '#c7c7f2';
export const THEME_INDIGO_300 = '#a2a2e6';
export const THEME_INDIGO_400 = '#8181d7';
export const THEME_INDIGO_500 = '#6666c4';
export const THEME_INDIGO_600 = '#5252b5';
export const THEME_INDIGO_700 = '#41419f';
export const THEME_INDIGO_800 = '#303083';
export const THEME_INDIGO_900 = '#222261';
export const THEME_INDIGO_950 = '#14143d';
export const THEME_BLUE_10 = '#e6ecf0';
export const THEME_BLUE_50 = '#cdd8e3';
export const THEME_BLUE_100 = '#b9cadc';
export const THEME_BLUE_200 = '#a6bdd5';
export const THEME_BLUE_300 = '#81a5c9';
export const THEME_BLUE_400 = '#628eb9';
export const THEME_BLUE_500 = '#4977a5';
export const THEME_BLUE_600 = '#346596';
export const THEME_BLUE_700 = '#235180';
export const THEME_BLUE_800 = '#153c63';
export const THEME_BLUE_900 = '#0b2640';
export const THEME_BLUE_950 = '#04101c';
export const THEME_LIGHT_BLUE_10 = '#eef3f7';
export const THEME_LIGHT_BLUE_50 = '#dde6ee';
export const THEME_LIGHT_BLUE_100 = '#c1d4e6';
export const THEME_LIGHT_BLUE_200 = '#a0bedc';
export const THEME_LIGHT_BLUE_300 = '#74a3d3';
export const THEME_LIGHT_BLUE_400 = '#4f8bc7';
export const THEME_LIGHT_BLUE_500 = '#3476b9';
export const THEME_LIGHT_BLUE_600 = '#2268ae';
export const THEME_LIGHT_BLUE_700 = '#145aa1';
export const THEME_LIGHT_BLUE_800 = '#0e4d8d';
export const THEME_LIGHT_BLUE_900 = '#0c4277';
export const THEME_LIGHT_BLUE_950 = '#0a3764';
export const THEME_GREEN_10 = '#eef4ef';
export const THEME_GREEN_50 = '#dde9de';
export const THEME_GREEN_100 = '#b1d6b5';
export const THEME_GREEN_200 = '#8cc497';
export const THEME_GREEN_300 = '#69af7d';
export const THEME_GREEN_400 = '#499767';
export const THEME_GREEN_500 = '#308258';
export const THEME_GREEN_600 = '#25744c';
export const THEME_GREEN_700 = '#1b653f';
export const THEME_GREEN_800 = '#155635';
export const THEME_GREEN_900 = '#0e4328';
export const THEME_GREEN_950 = '#052e19';
export const THEME_RED_10 = '#faf4f3';
export const THEME_RED_50 = '#f4e9e7';
export const THEME_RED_100 = '#ecd3d0';
export const THEME_RED_200 = '#e3bab5';
export const THEME_RED_300 = '#d59086';
export const THEME_RED_400 = '#c66e60';
export const THEME_RED_500 = '#ad4a3b';
export const THEME_RED_600 = '#a13322';
export const THEME_RED_700 = '#8f2110';
export const THEME_RED_800 = '#761405';
export const THEME_RED_900 = '#580d02';
export const THEME_RED_950 = '#380700';
export const THEME_LIGHT_RED_10 = '#fdf9f8';
export const THEME_LIGHT_RED_50 = '#faf2f1';
export const THEME_LIGHT_RED_100 = '#f6d9d5';
export const THEME_LIGHT_RED_200 = '#ebada2';
export const THEME_LIGHT_RED_300 = '#e07f6f';
export const THEME_LIGHT_RED_400 = '#d36250';
export const THEME_LIGHT_RED_500 = '#c24b38';
export const THEME_LIGHT_RED_600 = '#b53a26';
export const THEME_LIGHT_RED_700 = '#a02e1c';
export const THEME_LIGHT_RED_800 = '#8b2212';
export const THEME_LIGHT_RED_900 = '#751709';
export const THEME_LIGHT_RED_950 = '#5c1105';
export const BLACK = '#050506';
export const WHITE = '#fff';
export const BLUE_50 = '#e9f3fc';
export const BLUE_100 = '#cbe2f9';
export const BLUE_200 = '#9dc7f1';
export const BLUE_300 = '#63a6e9';
export const BLUE_400 = '#428fdc';
export const BLUE_500 = '#1f75cb';
export const BLUE_600 = '#2f68b4';
export const BLUE_700 = '#2f5ca0';
export const BLUE_800 = '#284779';
export const BLUE_900 = '#213454';
export const BLUE_950 = '#1d283e';
export const GRAY_10 = '#fbfafd';
export const GRAY_50 = '#ececef';
export const GRAY_100 = '#dcdcde';
export const GRAY_200 = '#bfbfc3';
export const GRAY_300 = '#a4a3a8';
export const GRAY_400 = '#89888d';
export const GRAY_500 = '#737278';
export const GRAY_600 = '#626168';
export const GRAY_700 = '#4c4b51';
export const GRAY_800 = '#3a383f';
export const GRAY_900 = '#28272d';
export const GRAY_950 = '#18171d';
export const GREEN_50 = '#ecf4ee';
export const GREEN_100 = '#c3e6cd';
export const GREEN_200 = '#91d4a8';
export const GREEN_300 = '#52b87a';
export const GREEN_400 = '#2da160';
export const GREEN_500 = '#108548';
export const GREEN_600 = '#2f7549';
export const GREEN_700 = '#306440';
export const GREEN_800 = '#225131';
export const GREEN_900 = '#1e3e28';
export const GREEN_950 = '#17291c';
export const ORANGE_50 = '#fdf1dd';
export const ORANGE_100 = '#f5d9a8';
export const ORANGE_200 = '#e9be74';
export const ORANGE_300 = '#d99530';
export const ORANGE_400 = '#c17d10';
export const ORANGE_500 = '#ab6100';
export const ORANGE_600 = '#995715';
export const ORANGE_700 = '#894b16';
export const ORANGE_800 = '#693c14';
export const ORANGE_900 = '#532e16';
export const ORANGE_950 = '#382315';
export const PURPLE_50 = '#f4f0ff';
export const PURPLE_100 = '#e1d8f9';
export const PURPLE_200 = '#cbbbf2';
export const PURPLE_300 = '#ac93e6';
export const PURPLE_400 = '#9475db';
export const PURPLE_500 = '#7b58cf';
export const PURPLE_600 = '#6a4fb4';
export const PURPLE_700 = '#5c47a6';
export const PURPLE_800 = '#493c83';
export const PURPLE_900 = '#342d59';
export const PURPLE_950 = '#27243e';
export const RED_50 = '#fcf1ef';
export const RED_100 = '#fdd4cd';
export const RED_200 = '#fcb5aa';
export const RED_300 = '#f57f6c';
export const RED_400 = '#ec5941';
export const RED_500 = '#dd2b0e';
export const RED_600 = '#c02f12';
export const RED_700 = '#a32c12';
export const RED_800 = '#812713';
export const RED_900 = '#582014';
export const RED_950 = '#3e1a14';
export const BRAND_CHARCOAL = '#171321';
export const BRAND_ORANGE_01 = '#fca326';
export const BRAND_ORANGE_02 = '#fc6d26';
export const BRAND_ORANGE_03 = '#e24329';
export const BRAND_PURPLE_01 = '#a989f5';
export const BRAND_PURPLE_02 = '#7759c2';
export const BRAND_GRAY_01 = '#d1d0d3';
export const BRAND_GRAY_02 = '#a2a1a6';
export const BRAND_GRAY_03 = '#74717a';
export const BRAND_GRAY_04 = '#45424d';
export const BRAND_GRAY_05 = '#2b2838';
export const T_GRAY_A_16 = 'rgba(05, 05, 06, 0.16)';
export const T_GRAY_A_24 = 'rgba(05, 05, 06, 0.24)';
export const T_GRAY_A_02 = 'rgba(05, 05, 06, 0.02)';
export const T_GRAY_A_04 = 'rgba(05, 05, 06, 0.04)';
export const T_GRAY_A_06 = 'rgba(05, 05, 06, 0.06)';
export const T_GRAY_A_08 = 'rgba(05, 05, 06, 0.08)';
export const T_WHITE_A_16 = 'rgba(255, 255, 255, 0.16)';
export const T_WHITE_A_24 = 'rgba(255, 255, 255, 0.24)';
export const T_WHITE_A_36 = 'rgba(255, 255, 255, 0.36)';
export const T_WHITE_A_02 = 'rgba(255, 255, 255, 0.02)';
export const T_WHITE_A_04 = 'rgba(255, 255, 255, 0.04)';
export const T_WHITE_A_06 = 'rgba(255, 255, 255, 0.06)';
export const T_WHITE_A_08 = 'rgba(255, 255, 255, 0.08)';
export const GL_ACTION_BORDER_RADIUS = '0.5rem';
export const GL_ACTION_DISABLED_FOREGROUND_COLOR = '#89888d';
export const GL_ACTION_DISABLED_BACKGROUND_COLOR = '#ececef';
export const GL_ACTION_DISABLED_BORDER_COLOR = '#dcdcde';
export const GL_ACTION_SELECTED_FOREGROUND_COLOR_DEFAULT = '#fff';
export const GL_ACTION_SELECTED_FOREGROUND_COLOR_HOVER = '#fff';
export const GL_ACTION_SELECTED_FOREGROUND_COLOR_FOCUS = '#fff';
export const GL_ACTION_SELECTED_FOREGROUND_COLOR_ACTIVE = '#fff';
export const GL_ACTION_SELECTED_BACKGROUND_COLOR_DEFAULT = '#1f75cb';
export const GL_ACTION_SELECTED_BACKGROUND_COLOR_HOVER = '#2f5ca0';
export const GL_ACTION_SELECTED_BACKGROUND_COLOR_FOCUS = '#2f5ca0';
export const GL_ACTION_SELECTED_BACKGROUND_COLOR_ACTIVE = '#284779';
export const GL_ACTION_SELECTED_BORDER_COLOR_DEFAULT = '#1f75cb';
export const GL_ACTION_SELECTED_BORDER_COLOR_HOVER = '#2f5ca0';
export const GL_ACTION_SELECTED_BORDER_COLOR_FOCUS = '#2f5ca0';
export const GL_ACTION_SELECTED_BORDER_COLOR_ACTIVE = '#284779';
export const GL_ACTION_NEUTRAL_FOREGROUND_COLOR_DEFAULT = '#28272d';
export const GL_ACTION_NEUTRAL_FOREGROUND_COLOR_HOVER = '#28272d';
export const GL_ACTION_NEUTRAL_FOREGROUND_COLOR_FOCUS = '#28272d';
export const GL_ACTION_NEUTRAL_FOREGROUND_COLOR_ACTIVE = '#28272d';
export const GL_ACTION_NEUTRAL_BACKGROUND_COLOR_DEFAULT = 'rgba(164, 163, 168, 0.0)';
export const GL_ACTION_NEUTRAL_BACKGROUND_COLOR_HOVER = 'rgba(164, 163, 168, 0.16)';
export const GL_ACTION_NEUTRAL_BACKGROUND_COLOR_FOCUS = 'rgba(164, 163, 168, 0.16)';
export const GL_ACTION_NEUTRAL_BACKGROUND_COLOR_ACTIVE = 'rgba(83, 81, 88, 0.24)';
export const GL_ACTION_NEUTRAL_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_ACTION_NEUTRAL_BORDER_COLOR_HOVER = 'transparent';
export const GL_ACTION_NEUTRAL_BORDER_COLOR_FOCUS = 'transparent';
export const GL_ACTION_NEUTRAL_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_ACTION_CONFIRM_FOREGROUND_COLOR_DEFAULT = '#1f75cb';
export const GL_ACTION_CONFIRM_FOREGROUND_COLOR_HOVER = '#2f5ca0';
export const GL_ACTION_CONFIRM_FOREGROUND_COLOR_FOCUS = '#2f5ca0';
export const GL_ACTION_CONFIRM_FOREGROUND_COLOR_ACTIVE = '#213454';
export const GL_ACTION_CONFIRM_BACKGROUND_COLOR_DEFAULT = 'rgba(99, 166, 233, 0.0)';
export const GL_ACTION_CONFIRM_BACKGROUND_COLOR_HOVER = 'rgba(99, 166, 233, 0.16)';
export const GL_ACTION_CONFIRM_BACKGROUND_COLOR_FOCUS = 'rgba(99, 166, 233, 0.16)';
export const GL_ACTION_CONFIRM_BACKGROUND_COLOR_ACTIVE = 'rgba(11, 92, 173, 0.24)';
export const GL_ACTION_CONFIRM_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_ACTION_CONFIRM_BORDER_COLOR_HOVER = 'transparent';
export const GL_ACTION_CONFIRM_BORDER_COLOR_FOCUS = 'transparent';
export const GL_ACTION_CONFIRM_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_ACTION_DANGER_FOREGROUND_COLOR_DEFAULT = '#dd2b0e';
export const GL_ACTION_DANGER_FOREGROUND_COLOR_HOVER = '#a32c12';
export const GL_ACTION_DANGER_FOREGROUND_COLOR_FOCUS = '#a32c12';
export const GL_ACTION_DANGER_FOREGROUND_COLOR_ACTIVE = '#582014';
export const GL_ACTION_DANGER_BACKGROUND_COLOR_DEFAULT = 'rgba(245, 127, 108, 0.0)';
export const GL_ACTION_DANGER_BACKGROUND_COLOR_HOVER = 'rgba(245, 127, 108, 0.16)';
export const GL_ACTION_DANGER_BACKGROUND_COLOR_FOCUS = 'rgba(245, 127, 108, 0.16)';
export const GL_ACTION_DANGER_BACKGROUND_COLOR_ACTIVE = 'rgba(174, 24, 0, 0.24)';
export const GL_ACTION_DANGER_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_ACTION_DANGER_BORDER_COLOR_HOVER = 'transparent';
export const GL_ACTION_DANGER_BORDER_COLOR_FOCUS = 'transparent';
export const GL_ACTION_DANGER_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_ACTION_STRONG_CONFIRM_BACKGROUND_COLOR_DEFAULT = '#1f75cb';
export const GL_ACTION_STRONG_CONFIRM_BACKGROUND_COLOR_HOVER = '#2f68b4';
export const GL_ACTION_STRONG_CONFIRM_BACKGROUND_COLOR_FOCUS = '#2f68b4';
export const GL_ACTION_STRONG_CONFIRM_BACKGROUND_COLOR_ACTIVE = '#2f5ca0';
export const GL_ACTION_STRONG_CONFIRM_FOREGROUND_COLOR_DEFAULT = '#fff';
export const GL_ACTION_STRONG_CONFIRM_FOREGROUND_COLOR_HOVER = '#fff';
export const GL_ACTION_STRONG_CONFIRM_FOREGROUND_COLOR_FOCUS = '#fff';
export const GL_ACTION_STRONG_CONFIRM_FOREGROUND_COLOR_ACTIVE = '#fff';
export const GL_ACTION_STRONG_CONFIRM_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_ACTION_STRONG_CONFIRM_BORDER_COLOR_HOVER = 'transparent';
export const GL_ACTION_STRONG_CONFIRM_BORDER_COLOR_FOCUS = 'transparent';
export const GL_ACTION_STRONG_CONFIRM_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_ACTION_STRONG_NEUTRAL_BACKGROUND_COLOR_DEFAULT = '#626168';
export const GL_ACTION_STRONG_NEUTRAL_BACKGROUND_COLOR_HOVER = '#4c4b51';
export const GL_ACTION_STRONG_NEUTRAL_BACKGROUND_COLOR_FOCUS = '#4c4b51';
export const GL_ACTION_STRONG_NEUTRAL_BACKGROUND_COLOR_ACTIVE = '#3a383f';
export const GL_ACTION_STRONG_NEUTRAL_FOREGROUND_COLOR_DEFAULT = '#fff';
export const GL_ACTION_STRONG_NEUTRAL_FOREGROUND_COLOR_HOVER = '#fff';
export const GL_ACTION_STRONG_NEUTRAL_FOREGROUND_COLOR_FOCUS = '#fff';
export const GL_ACTION_STRONG_NEUTRAL_FOREGROUND_COLOR_ACTIVE = '#fff';
export const GL_ACTION_STRONG_NEUTRAL_BORDER_COLOR_DEFAULT = 'transparent';
export const GL_ACTION_STRONG_NEUTRAL_BORDER_COLOR_HOVER = 'transparent';
export const GL_ACTION_STRONG_NEUTRAL_BORDER_COLOR_FOCUS = 'transparent';
export const GL_ACTION_STRONG_NEUTRAL_BORDER_COLOR_ACTIVE = 'transparent';
export const GL_BACKGROUND_COLOR_DEFAULT = '#fff';
export const GL_BACKGROUND_COLOR_SUBTLE = '#fbfafd';
export const GL_BACKGROUND_COLOR_STRONG = '#ececef';
export const GL_BACKGROUND_COLOR_DISABLED = '#fbfafd';
export const GL_BACKGROUND_COLOR_OVERLAP = '#fff';
export const GL_BACKGROUND_COLOR_SECTION = '#fff';
export const GL_BACKGROUND_COLOR_OVERLAY = 'rgba(05, 05, 06, 0.24)';
export const GL_CONTROL_BACKGROUND_COLOR_DEFAULT = '#fff';
export const GL_CONTROL_BACKGROUND_COLOR_DISABLED = '#fbfafd';
export const GL_CONTROL_BACKGROUND_COLOR_CONCATENATION = '#fbfafd';
export const GL_CONTROL_BACKGROUND_COLOR_READONLY = 'rgba(05, 05, 06, 0.02)';
export const GL_CONTROL_BACKGROUND_COLOR_SELECTED_DEFAULT = '#1f75cb';
export const GL_CONTROL_BACKGROUND_COLOR_SELECTED_HOVER = '#2f5ca0';
export const GL_CONTROL_BACKGROUND_COLOR_SELECTED_FOCUS = '#2f5ca0';
export const GL_CONTROL_BORDER_COLOR_DEFAULT = '#89888d';
export const GL_CONTROL_BORDER_COLOR_HOVER = '#626168';
export const GL_CONTROL_BORDER_COLOR_FOCUS = '#28272d';
export const GL_CONTROL_BORDER_COLOR_DISABLED = '#dcdcde';
export const GL_CONTROL_BORDER_COLOR_ERROR = '#dd2b0e';
export const GL_CONTROL_BORDER_COLOR_SELECTED_DEFAULT = '#1f75cb';
export const GL_CONTROL_BORDER_COLOR_SELECTED_HOVER = '#2f5ca0';
export const GL_CONTROL_BORDER_COLOR_SELECTED_FOCUS = '#2f5ca0';
export const GL_CONTROL_BORDER_RADIUS = '0.5rem';
export const GL_CONTROL_TEXT_COLOR_ERROR = '#c02f12';
export const GL_CONTROL_TEXT_COLOR_VALID = '#2f7549';
export const GL_CONTROL_PLACEHOLDER_COLOR = '#89888d';
export const GL_CONTROL_INDICATOR_COLOR_SELECTED = '#fff';
export const GL_CONTROL_INDICATOR_COLOR_DISABLED = '#737278';
export const GL_FEEDBACK_BORDER_RADIUS = '0.5rem';
export const GL_FEEDBACK_STRONG_BACKGROUND_COLOR = '#3a383f';
export const GL_FEEDBACK_STRONG_TEXT_COLOR = '#fff';
export const GL_FEEDBACK_STRONG_ICON_COLOR = '#fff';
export const GL_FEEDBACK_STRONG_LINK_COLOR = '#63a6e9';
export const GL_FEEDBACK_NEUTRAL_BACKGROUND_COLOR = '#ececef';
export const GL_FEEDBACK_NEUTRAL_TEXT_COLOR = '#4c4b51';
export const GL_FEEDBACK_NEUTRAL_ICON_COLOR = '#626168';
export const GL_FEEDBACK_INFO_BACKGROUND_COLOR = '#e9f3fc';
export const GL_FEEDBACK_INFO_TEXT_COLOR = '#2f5ca0';
export const GL_FEEDBACK_INFO_ICON_COLOR = '#2f68b4';
export const GL_FEEDBACK_SUCCESS_BACKGROUND_COLOR = '#ecf4ee';
export const GL_FEEDBACK_SUCCESS_TEXT_COLOR = '#306440';
export const GL_FEEDBACK_SUCCESS_ICON_COLOR = '#2f7549';
export const GL_FEEDBACK_WARNING_BACKGROUND_COLOR = '#fdf1dd';
export const GL_FEEDBACK_WARNING_TEXT_COLOR = '#894b16';
export const GL_FEEDBACK_WARNING_ICON_COLOR = '#995715';
export const GL_FEEDBACK_DANGER_BACKGROUND_COLOR = '#fcf1ef';
export const GL_FEEDBACK_DANGER_TEXT_COLOR = '#a32c12';
export const GL_FEEDBACK_DANGER_ICON_COLOR = '#c02f12';
export const GL_FOCUS_RING_OUTER_COLOR = '#1f75cb';
export const GL_FOCUS_RING_INNER_COLOR = '#fff';
export const GL_HIGHLIGHT_MATCH_BACKGROUND_COLOR = '#ab6100';
export const GL_HIGHLIGHT_MATCH_TEXT_COLOR = '#fff';
export const GL_HIGHLIGHT_TARGET_BACKGROUND_COLOR = '#e9f3fc';
export const GL_HIGHLIGHT_TARGET_BORDER_COLOR = '#9dc7f1';
export const GL_ICON_COLOR_DEFAULT = '#3a383f';
export const GL_ICON_COLOR_SUBTLE = '#626168';
export const GL_ICON_COLOR_STRONG = '#18171d';
export const GL_ICON_COLOR_DISABLED = '#89888d';
export const GL_ICON_COLOR_LINK = '#2f5ca0';
export const GL_ICON_COLOR_INFO = '#2f5ca0';
export const GL_ICON_COLOR_WARNING = '#995715';
export const GL_ICON_COLOR_DANGER = '#c02f12';
export const GL_ICON_COLOR_SUCCESS = '#2f7549';
export const GL_STATUS_NEUTRAL_BACKGROUND_COLOR = '#dcdcde';
export const GL_STATUS_NEUTRAL_TEXT_COLOR = '#4c4b51';
export const GL_STATUS_NEUTRAL_ICON_COLOR = '#737278';
export const GL_STATUS_INFO_BACKGROUND_COLOR = '#cbe2f9';
export const GL_STATUS_INFO_TEXT_COLOR = '#2f5ca0';
export const GL_STATUS_INFO_ICON_COLOR = '#1f75cb';
export const GL_STATUS_SUCCESS_BACKGROUND_COLOR = '#c3e6cd';
export const GL_STATUS_SUCCESS_TEXT_COLOR = '#306440';
export const GL_STATUS_SUCCESS_ICON_COLOR = '#108548';
export const GL_STATUS_WARNING_BACKGROUND_COLOR = '#f5d9a8';
export const GL_STATUS_WARNING_TEXT_COLOR = '#894b16';
export const GL_STATUS_WARNING_ICON_COLOR = '#ab6100';
export const GL_STATUS_DANGER_BACKGROUND_COLOR = '#fdd4cd';
export const GL_STATUS_DANGER_TEXT_COLOR = '#a32c12';
export const GL_STATUS_DANGER_ICON_COLOR = '#dd2b0e';
export const GL_STATUS_BRAND_BACKGROUND_COLOR = '#e1d8f9';
export const GL_STATUS_BRAND_TEXT_COLOR = '#5c47a6';
export const GL_STATUS_BRAND_ICON_COLOR = '#7b58cf';
export const GL_TEXT_PRIMARY = '#28272d';
export const GL_TEXT_SECONDARY = '#737278';
export const GL_TEXT_TERTIARY = '#89888d';
export const GL_TEXT_COLOR_DEFAULT = '#3a383f';
export const GL_TEXT_COLOR_SUBTLE = '#626168';
export const GL_TEXT_COLOR_STRONG = '#18171d';
export const GL_TEXT_COLOR_HEADING = '#18171d';
export const GL_TEXT_COLOR_LINK = '#2f5ca0';
export const GL_TEXT_COLOR_WARNING = '#995715';
export const GL_TEXT_COLOR_DANGER = '#c02f12';
export const GL_TEXT_COLOR_SUCCESS = '#2f7549';
export const GL_TEXT_COLOR_DISABLED = '#89888d';
